module.exports = __webpack_public_path__ + "img/plus_circle.e87f4f95.svg";